import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loadingMessage: {
		id: 'jql-builder-basic-picker.async-select.menu-list.loading-message.loading-message',
		defaultMessage: 'Loading...',
		description: 'The text for when options are being loaded in dropdown',
	},
});
